import React, { useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import "leaflet-draw/dist/leaflet.draw.css";
import L from "leaflet";
import "leaflet-draw";

const AOIDrawControl = ({
  onDrawComplete,
  onDrawDeleted,
  isDrawing,
  filterCleared,
}) => {
  const map = useMap();
  const [featureGroup] = useState(new L.FeatureGroup());

  useEffect(() => {
    if (!map.hasLayer(featureGroup)) {
      map.addLayer(featureGroup);
    }

    if (filterCleared) {
      featureGroup.clearLayers();
    }
    let drawControl = null;

    if (isDrawing) {
      drawControl = new L.Control.Draw({
        edit: {
          featureGroup: featureGroup,
        },
        draw: {
          circle: false,
          polygon: true,
          rectangle: true,
          circlemarker: false,
          polyline: false,
          marker: false,
        },
      });

      map.addControl(drawControl);

      map.on("draw:created", (event) => {
        const layer = event.layer;
        const geojson = layer.toGeoJSON();
        featureGroup.addLayer(layer);
        if (onDrawComplete) {
          onDrawComplete(geojson);
        }
      });
      map.on("draw:deleted", () => {
        if (onDrawDeleted) {
          onDrawDeleted();
        }
      });
    }

    return () => {
      if (drawControl) {
        map.removeControl(drawControl);
      }
    };
  }, [
    isDrawing,
    map,
    onDrawComplete,
    onDrawDeleted,
    featureGroup,
    filterCleared,
  ]);
};

export default AOIDrawControl;
